var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircle3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 163,
    viewBox: "0 0 164 163",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.70801,
    y: 2,
    width: 158.5,
    height: 158.5,
    rx: 79.25,
    stroke: "#403841",
    strokeWidth: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.70801,
    y: 8,
    width: 146.5,
    height: 146.5,
    rx: 73.25,
    fill: "#403841"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46 86C46 70.536 58.536 58 74 58H95C107.703 58 118 68.2975 118 81C118 93.7025 107.703 104 95 104H46V86Z",
    stroke: "white",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle3);
export default __webpack_public_path__ + "static/media/circle_3.233e1cdd71ea341092172e52bb49a506.svg";
export { ForwardRef as ReactComponent };